<template>
  <div id="app">
    <header-item></header-item>
    <div class="main-box">
      <router-view></router-view>
    </div>
    <footer-item></footer-item>
  </div>
</template>

<script>
import headerItem from "@/components/headerItem.vue";
import footerItem from "@/components/footerItem.vue";

export default {
  name: "frame",
  data() {
    return {};
  },
  components: {
    headerItem,
    footerItem
  },
  methods: {
    test() {
      // console.log(123);
    }
  }
};
</script>


<style lang="less">


body {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif !important;
  overflow-y: scroll;
}
.can-touch {
  cursor: pointer;
}
.item-container {
  max-width: @baseW;
  margin: auto;
}

@media (max-width: 768px) {
  .main-box {
    padding-top: 60px;
  }
  .m-h-container {
    background: #f7f7f7 !important;
  }
}
</style>
